
import { BrowserRouter } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';
import { AppRoutes } from './router';
import WhatsAppButton from './components/feature/WhatsAppButton';
import { supabase } from './lib/supabase';

function App() {
  const [isAuthReady, setIsAuthReady] = useState(false);

  useEffect(() => {
    // La vuelta desde Google (o cualquier "entrar con...").
    //
    // Google devuelve a la persona a la app con un permiso pegado en la
    // dirección. Hay DOS formas de que venga, y antes acá solo se
    // miraba una:
    //
    //   · `#access_token=...`  — la forma vieja
    //   · `?code=...`          — la forma nueva y más segura, que es la
    //                            que usa esta app (está configurada como
    //                            'pkce' en lib/supabase.ts)
    //
    // O sea que el día que se active Google, el camino real habría sido
    // el que no se estaba mirando. No habría roto nada —la librería
    // canjea el código sola— pero la app se habría pintado antes de que
    // la sesión existiera, y quien volviera de Google habría visto por
    // un instante la pantalla de "inicia sesión" justo después de
    // iniciar sesión. Peor todavía si cae en /dashboard, que está
    // detrás del candado: lo habría rebotado a /auth.
    //
    // Por eso acá se espera a que la sesión exista ANTES de pintar nada.
    const handleOAuthCallback = async () => {
      const hash = new URLSearchParams(window.location.hash.substring(1));
      const query = new URLSearchParams(window.location.search);
      const volviendoDeGoogle = Boolean(hash.get('access_token') || query.get('code'));

      if (!volviendoDeGoogle) {
        setIsAuthReady(true);
        return;
      }

      // Se pregunta varias veces en vez de esperar un rato fijo: el
      // canje tarda distinto según la red, y medio segundo alcanzaba en
      // la computadora del que programa pero no siempre en un celular.
      let sesion = null;
      for (let intento = 0; intento < 20 && !sesion; intento++) {
        const { data } = await supabase.auth.getSession();
        sesion = data.session;
        if (!sesion) await new Promise((seguir) => setTimeout(seguir, 250));
      }

      // Se limpia la dirección para que el permiso no quede a la vista
      // ni se guarde en el historial del navegador.
      window.history.replaceState({}, document.title, window.location.pathname);

      if (sesion && (window.location.pathname === '/' || window.location.pathname === '/auth')) {
        window.location.href = '/dashboard';
        return;
      }

      setIsAuthReady(true);
    };

    handleOAuthCallback();
  }, []);

  if (!isAuthReady) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="bg-white rounded-2xl p-8 shadow-xl">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="text-gray-600 mt-4 text-center">Iniciando sesión...</p>
        </div>
      </div>
    );
  }

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Suspense
        fallback={
          <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="text-gray-600 mt-4 text-center">Cargando...</p>
            </div>
          </div>
        }
      >
        <AppRoutes />
      </Suspense>

      <WhatsAppButton />
    </BrowserRouter>
  );
}

export default App;
